import JSONBig from 'json-bigint'

const jsonBig = JSONBig({ storeAsString: true })

// normalizeApiId 将 H5 路由和接口中的业务 ID 统一为字符串，避免提交前被 Number 截断。
export function normalizeApiId(value) {
  if (typeof value === 'bigint') return value > 0n ? value.toString() : ''
  if (typeof value === 'number') return Number.isSafeInteger(value) && value > 0 ? String(value) : ''
  if (typeof value !== 'string') return ''
  const normalized = value.trim()
  return /^\d+$/.test(normalized) && normalized !== '0' ? normalized : ''
}

// parseBigIntJson 在 Axios 默认解析前把 JSON 大整数保留为字符串。
export function parseBigIntJson(data) {
  if (typeof data !== 'string' || !data.trim()) return data
  try {
    return jsonBig.parse(data)
  } catch {
    return data
  }
}

